import type { FC, PropsWithChildren } from 'react';
import React, { useMemo } from 'react';
import { NamedContainer } from '@alfa-bank/site-named-container';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

import type { TMenuItem } from './models';

const MockLink = ({ children: linkChildren }: PropsWithChildren) => <>{linkChildren}</>;

export const MenuItem: FC<PropsWithChildren<TMenuItem>> = ({
    Link,
    Tooltip,
    children,
    link,
    newWindow,
    styles,
    title,
    tooltipContent,
    type,
}) => {
    const linkRenderer = useMemo(() => {
        const hasLink = !!link;
        const isHeader = type === 'header';

        const Component = hasLink ? Link : MockLink;

        return (
            <Component
                border="hidden"
                href={link}
                target={newWindow ? '_blank' : '_self'}
                title={tooltipContent ? undefined : title}
            >
                <Text
                    className={hasLink ? styles.hoverable : undefined}
                    tag="span"
                    textTransform={isHeader ? 'uppercase' : undefined}
                    view={isHeader ? 'accent-secondary-medium' : 'primary-small'}
                >
                    {children}
                </Text>
            </Component>
        );
    }, [Link, link, children, newWindow, styles.hoverable, title, type, tooltipContent]);

    const tooltipRenderer = useMemo(
        () =>
            tooltipContent ? (
                <Tooltip position="right">
                    <NamedContainer name="content">{tooltipContent}</NamedContainer>
                    {linkRenderer}
                </Tooltip>
            ) : (
                linkRenderer
            ),
        [Tooltip, linkRenderer, tooltipContent]
    );

    return <div className={styles.container}>{tooltipRenderer}</div>;
};
